/**
 * @fileoverview Input/output schemas for the synopsis-extraction-pipeline-v3 composite.
 *
 * This composite accepts the full source text and a target token count,
 * and returns a single synopsis. It internally decides whether to use
 * single-pass extraction or the chunked map-reduce pipeline based on
 * the input size.
 */

import { z } from 'zod';

// =============================================================================
// FLOW INPUT SCHEMA
// =============================================================================

export const InputSchema = z.object({
  logId: z.string(),
  model: z.string(),
  projectId: z.string().optional(),

  /** The full source text to create a synopsis from. */
  textInput: z.string().describe('The full text content of the document to create a synopsis from.'),

  /** Target number of tokens for the synopsis (calculated as 3% of input, minimum 1000). */
  targetTokens: z.number().describe('Target number of tokens for the synopsis.'),

  /** Title of the book/story, if known. Used in chunk prompts for context. */
  title: z.string().optional().describe('Title of the book/story being summarized.'),
});

export type Input = z.infer<typeof InputSchema>;

// =============================================================================
// OUTPUT SCHEMA
// =============================================================================

export const OutputSchema = z.object({
  /** The generated synopsis. */
  synopsis: z.string().describe('A condensed synopsis capturing the essential plot, characters, themes, and narrative arc of the input text.'),
});

export type Output = z.infer<typeof OutputSchema>;
